import type { UpdateProjectDto } from '@inference.engine/workspace-api-client/web';
import type { ProjectDetail } from '@/entities/project';
import { defaultFormData, type CreateProjectFormData } from '@/features/edit-project/model/schema';

function splitCsv(value: string | null | undefined): string[] {
  if (!value) return [];
  return value
    .split(',')
    .map((v) => v.trim())
    .filter(Boolean);
}

export function mapProjectToFormData(project: ProjectDetail): CreateProjectFormData {
  return {
    type: project.type,
    title: project.title || defaultFormData.title,
    description: project.description || defaultFormData.description,
    tags: project.tags.map((tag) => tag.name),
    markets: splitCsv(project.market),
    status: project.status,
    startDate: project.startDate ? project.startDate.slice(0, 10) : undefined,
    deadline: project.deadline ? project.deadline.slice(0, 10) : undefined,
    audienceIds: project.audiences?.map((a) => a.id) ?? [],
  };
}

export function mapFormDataToUpdatePayload(formData: CreateProjectFormData): UpdateProjectDto {
  return {
    type: formData.type,
    title: formData.title,
    description: formData.description || undefined,
    tags: formData.tags ?? [],
    market: formData.markets.join(', ') || undefined,
    status: formData.status || undefined,
    // Send explicit null (not undefined) when cleared so the backend clears
    // the column. The generated DTO is `string | null`: undefined = leave
    // alone, null = clear.
    startDate: formData.startDate || null,
    deadline: formData.deadline || null,
    audienceIds: formData.audienceIds?.length ? formData.audienceIds : undefined,
  };
}
